import { createTheme } from '@mui/material/styles';
import { getConfigI18n } from '../i18n/tazmeni18n';
const theme = createTheme({
  spacing: (factor: number) => `${0.25 * factor}rem`, // Set spacing based on 0.25rem units
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'contained', // Set the default variant to 'contained'
      },

      styleOverrides: {
        root: {
          textTransform: 'none', // Ensure all buttons have no text transformation
          boxShadow: '4px 4px 10px 0 rgba(0,0,0,0.10)',
          // "&.Mui-disabled": {
          //   backgroundColor: "#1d84d5", // Equivalent to bg-gray-300 in Tailwind CSS
          //   color: "#125284", // Equivalent to text-gray-700 in Tailwind CSS
          // },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          // Apply your custom shadow
          boxShadow: '4px 4px 10px 0 rgba(0, 0, 0, 0.1)',
          // You can also add other styles if needed
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#083E60',
      light: '#9EC2D9',
    },
    secondary: {
      main: '#9EC2D9',
    },
    background: {
      default: '#F3F5F9',
      paper: '#FFFFFF', // Set the background color for paper components (like dialogs)
    },
    text: {
      primary: '#083E60',
      secondary: '#1A2027',
    },
  },
  direction: getConfigI18n().selectedLang == 'en' ? 'ltr' : 'rtl',
});

export default theme;
